import { componentTypes, Schema } from '@data-driven-forms/react-form-renderer';
import { GridProps } from '@mui/system';

export interface TagSchemaData {
  tagName: string,
  editData?: any,

}

export const TagSchema  = (props: TagSchemaData) => {
  const {
    editData,
  } = props;
  return {
    fields: [
      {
        component: componentTypes.TEXT_FIELD,
        label: 'Tags',
        placeholder: 'Tag Name',
        name: 'tagName',
        required: true,
        disabled: false,
        initialValue: editData?.tagName,
        validate: [{
          type: 'required',
          message: 'Tag name is required'
        }]
      }
    ]
  } as Schema extends GridProps ? GridProps : never;
};
